import { render, staticRenderFns } from "./TakeawayWeb.vue?vue&type=template&id=33adeee5&scoped=true&"
import script from "./TakeawayWeb.vue?vue&type=script&lang=js&"
export * from "./TakeawayWeb.vue?vue&type=script&lang=js&"
import style0 from "./TakeawayWeb.vue?vue&type=style&index=0&id=33adeee5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33adeee5",
  null
  
)

export default component.exports